import { Suspense, lazy, useState } from "react";

import { IconButton } from "@/components/elements/Button";
import LoadingSpinner from "@/components/elements/LoadingSpinner";
import { SlideOver } from "@/components/elements/SlideOver";
import Tooltip from "@/components/elements/Tooltip";
import Center from "@/components/elements/layout/Center";

import { PanelRightCloseIcon, PanelRightOpenIcon } from "lucide-react";
import { useViewDataSourceSlideOver } from "./useViewDataSource";

const ViewDataSource = lazy(() => import("./ViewDataSource"));

export function ViewDataSourceSlideOverContainer({
  show,
  syncId,
}: {
  show?: boolean;
  syncId?: string;
}) {
  const { onClose } = useViewDataSourceSlideOver();
  const [view, setView] = useState<"minimal" | "expanded">("minimal");

  let config =
    view === "minimal"
      ? {
          size: "xl" as const,
          icon: <PanelRightOpenIcon />,
          text: "Expand View",
        }
      : {
          size: "4xl" as const,
          icon: <PanelRightCloseIcon />,
          text: "Minimize View",
        };

  return (
    <SlideOver show={!!show} onClose={onClose} size={config.size} bgOverlay>
      <Suspense
        fallback={
          <Center className="h-full w-full">
            <LoadingSpinner />
          </Center>
        }
      >
        {syncId && <ViewDataSource syncId={syncId} onClose={onClose} />}
      </Suspense>
      <div className="absolute top-6 left-0">
        <Tooltip content={config.text}>
          <IconButton
            icon={config.icon}
            className="-translate-x-1/2 rounded-full bg-background"
            variant="outline"
            onClick={() =>
              setView((prev) => (prev === "minimal" ? "expanded" : "minimal"))
            }
          />
        </Tooltip>
      </div>
    </SlideOver>
  );
}
